export const IS_EXPORTS: Array<{
    key: string;
    value: string;
}> = [
    {
        key: "true",
        value: "Evet"
    },
    {
        key: "false",
        value: "Hayır"
    }
];
